export const OrderText = {
  TITLE: "You are confirming to place an order for",
};
